module.exports = __webpack_public_path__ + "images/emoji/dromedary_camel.b425f6357bbdba7e5187.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dromedary_camel.png
// module id = 9Z6k
// module chunks = 1